export default {
  biSiteVisits: 'BI_SITE_VISITS',
  biSiteVisitsByDate: 'BI_SITE_VISITS_BY_DATE',
  biSiteVisitsBySiteAndDate: 'BI_SITE_VISITS_BY_SITE_AND_DATE',
  setLoadingState: 'BI_SITE_VISITS_SET_LOADING_STATE',
};
